import React from 'react';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import WrapperSection from '../../components/global/WrapperSection';
import FormAddEditStudent from '../../components/students/FormAddEditStudent';
import { useParams } from 'react-router-dom';
import { useGetStudent } from '../../hooks/students/useGetStudent';
import LoadingPage from '../../components/global/LoadingPage';
const EditStudent = () => {
    const { id } = useParams();
    const { student, isLoading } = useGetStudent(id);
    if (isLoading) return <LoadingPage />;
    return (<WrapperSection><GlobalBreadcrumbs /><FormAddEditStudent isEdit currentData={student?.data} /></WrapperSection>);
};
export default EditStudent;
